import script from "./CustomColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomColumn.vue?vue&type=script&setup=true&lang=ts"

import "./CustomColumn.vue?vue&type=style&index=0&id=2795fbc6&lang=scss"

const __exports__ = script;

export default __exports__